import { useMutation } from '@tanstack/react-query';
import { getTopicFile } from 'src/apis/helpdesk/topic.api';
import { formatDate, getContentType } from 'src/utils/utils';
import JSZip from 'jszip';
type File = {
  path: string;
  title: string;
  fileType: string;
};

function useDownload() {
  const { mutate, isLoading } = useMutation({
    mutationFn: (file: File) => getTopicFile(file?.path, file?.title)
  });
  const zip = new JSZip();

  function preview<T>(file: T) {
    mutate(file as File, {
      onSuccess: (response, variables) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: getContentType(variables?.fileType)
          })
        );
        window.open(url, '_blank');
      }
    });
  }

  function download<T>(file: T) {
    mutate(file as File, {
      onSuccess: (response, variables) => {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: getContentType(variables?.fileType)
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', variables?.title);
        document.body.appendChild(link);
        link.click();
      }
    });
  }

  function downloadMultiple<T>(files: T[]) {
    const index = 0;
    handleGetFile(files, index);
  }

  const handleGetFile = <T>(files: T[], index: number) => {
    const file = files[index];
    mutate(file as File, {
      onSuccess: (response) => {
        onGetFileComplete(response.data, index, files);
      }
    });
  };

  const onGetFileComplete = <T>(data: Blob, index: number, files: T[]) => {
    if (index < (files?.length || 0)) {
      const file = files?.[index] as File;

      zip.file(
        String(file?.title),
        new Blob([data], {
          type: getContentType(String(file?.fileType))
        })
      );

      if (index < (files?.length || 0) - 1) {
        handleGetFile(files, index + 1);
      } else {
        zip.generateAsync({ type: 'blob' }).then((content) => {
          const url = URL.createObjectURL(content);
          const a = document.createElement('a');
          a.href = url;
          a.download = `download-${formatDate(new Date()) as string}`.replaceAll('/', '');
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      }
    }
  };

  return { download, downloadMultiple, preview, isLoading };
}

export default useDownload;
